export default __webpack_public_path__ + "static/media/sanjivani-tea-bags.b478cb55.jpg";